import { GraphComponent, IRenderTreeElement } from '@yfiles/yfiles';

// Takes an element (a heat map, the moving packets) off a canvas's render tree, if it's still there. A canvas that has
// been cleaned up, as when the page or view showing it goes, no longer holds its elements, and yFiles throws "The
// element is not part of this render tree" when one is removed then; there is nothing left to remove, so that's fine
export const removeFromRenderTree = (graphComponent: GraphComponent | undefined | null, element: IRenderTreeElement | undefined | null) => {
    if (!graphComponent || !element) return;
    try {
        graphComponent.renderTree.remove(element);
    } catch {
        // already gone with its canvas
    }
};

// Whether a canvas is still on the page. When the page or view showing it goes, Angular takes its element off the page
// and the canvas is cleaned up; its graph can't be changed after that (yFiles fails as it removes the drawing of what
// changed), so whatever was tidying it just lets it go
export const isCanvasOnPage = (graphComponent: GraphComponent | undefined | null) => !!graphComponent?.htmlElement?.isConnected;
